import { render } from "./ItemRecordLot.vue?vue&type=template&id=b0670846"
import script from "./ItemRecordLot.vue?vue&type=script&lang=js"
export * from "./ItemRecordLot.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__